import * as React from 'react';
var loading = require('../assets/img/loading.svg');

export interface ILoaderProps {}

interface ILoaderState {
    height: number;
}

export default class Loader extends React.Component<
    ILoaderProps,
    ILoaderState
> {
    constructor(props: ILoaderProps) {
        super(props);
        this.state = {
            height: 600
        };
    }

    componentWillMount() {
        this.setState({
            height: window.innerHeight - 320
        });
    }

    render() {
        return (
            <div className="loaderSpace" style={{ height: this.state.height }}>
                <div className="loaderSplice">
                    <div className="loader">
                        <img src={loading} alt="WetNotes loading ..." />
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Loader.tsx